import { Outlet } from '@xing-com/crate-xinglet';
import { GridContainer, GridItem } from '@xing-com/grid';

import { Styled } from './styles';

export const Component: React.FC = () => {
  return (
    <GridContainer variant="FullSize">
      <GridItem span={12}>
        <Styled.ArticlesPageWrapper>
          <Outlet />
        </Styled.ArticlesPageWrapper>
      </GridItem>
    </GridContainer>
  );
};
